module.exports = __webpack_public_path__ + "img/ow-logo.efe1ef03.svg";